var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canSeeAllDepartments
    ? _c(
        "div",
        { staticClass: "department-group-selector" },
        [
          _c(
            "v-menu",
            {
              attrs: { "close-on-content-click": false, "offset-y": "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "div",
                          _vm._g(
                            _vm._b(
                              { staticClass: "department-picker-activator" },
                              "div",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c("v-text-field", {
                              staticClass: "department-picker subtitle-2",
                              staticStyle: { "max-width": "200px" },
                              attrs: {
                                "append-icon": "$dropdown",
                                dense: "",
                                "hide-details": "",
                                outlined: "",
                                readonly: "",
                                value: _vm.selectedName
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                3840742393
              ),
              model: {
                value: _vm.menu,
                callback: function($$v) {
                  _vm.menu = $$v
                },
                expression: "menu"
              }
            },
            [
              _c("v-card", { staticClass: "department-group-menu" }, [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "department-group-menu-column departments"
                      },
                      [
                        _c("v-subheader", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$tc("labels.department", 2)) +
                              "\n          "
                          )
                        ]),
                        _c(
                          "v-list",
                          {
                            staticClass: "department-group-menu-list py-0",
                            attrs: { dense: "" }
                          },
                          _vm._l(_vm.departmentItems, function(item) {
                            return _c(
                              "v-list-item",
                              {
                                key: item.value,
                                staticClass: "department-item",
                                attrs: {
                                  color: "primary",
                                  "input-value":
                                    item.value === _vm.selectedValue
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.select(item.value)
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.name) +
                                      "\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm.groupItems.length > 0
                      ? [
                          _c("v-divider", { attrs: { vertical: "" } }),
                          _c(
                            "div",
                            {
                              staticClass: "department-group-menu-column groups"
                            },
                            [
                              _c("v-subheader", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$tc("labels.departmentGroup", 2)
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _c(
                                "v-list",
                                {
                                  staticClass:
                                    "department-group-menu-list py-0",
                                  attrs: { dense: "" }
                                },
                                _vm._l(_vm.groupItems, function(item) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: item.value,
                                      staticClass: "department-group-item",
                                      attrs: {
                                        color: "primary",
                                        "input-value":
                                          item.value === _vm.selectedValue
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.select(item.value)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.name) +
                                            "\n                "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ])
            ],
            1
          )
        ],
        1
      )
    : _c(
        "span",
        {
          staticClass: "title page-title d-inline-block text-truncate",
          style: _vm.pageTitleStyle
        },
        [_vm._v("\n  " + _vm._s(_vm.activeDepartment.name) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }